import { useTranslation } from "react-i18next";

import { useOriginalEquipment } from "./useOriginalEquipment";

export const originalEquipmentOnly = "1";

export const useOriginalEquipmentOptions = (): Option[] => {
  const [selectedOptions] = useOriginalEquipment();
  const { t } = useTranslation();

  const options = [
    {
      checked: selectedOptions === originalEquipmentOnly,
      label: t("searchResults.originalEquipmentOnly"),
      value: originalEquipmentOnly,
    },
    {
      checked: selectedOptions !== originalEquipmentOnly,
      label: t("searchResults.originalEquipmentAll"),
      value: "2",
    },
  ];
  return options;
};

type Option = {
  checked: boolean;
  label: string;
  value: string;
};
